import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import storage from '@/utils/localstorage'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

// 状态
const state = {
  isCollapse : false,
  menuList : [],
  domainInfo: {},
  // 公司切换信息
  switchInfo: {
    companyList: [],
    settlementList: [],
    companyId: '',
    settlementId: localStorage.getItem("nowCompany")?localStorage.getItem("nowCompany").id:'' || '',
    isAlipay: false,
    // nowCompany: JSON.parse(localStorage.getItem("nowCompany")) || {name: '', id: 0},
    nowCompany: {},
    nowCompanyTax: 0
  },
  routePath : null,
  userInfo: {},
  isContract: 1,
  userPermissions : [],
  // 错误响应弹窗标志，避免重复弹出
  responseErrorMessageBoxMark:false,
  // 按钮类型
  buttonType : process.env.VUE_APP_BUTTON_TYPE,
  // 全局的loading状态控制
  loadingStatus: false,
  // 用户手机号
  userPhone:'',
 
}
const mutations = {
  
  /**
   * @description 左侧导航折叠状态控制
   * @author YM
   * @date 2019-01-10
   * @param {*} state
   */
   changephone(state,data){
    state.userPhone=data
    localStorage.setItem("accountPhone",state.userPhone )
   },
   
  changeCollapse (state) {
    state.isCollapse = !state.isCollapse
  },
  handleCollapse (state,data) {
    state.isCollapse = data
  },
  handleIsContract (state,data) {
    state.isContract = data
  },
  /**
   * @description 处理菜单
   * @author YM
   * @date 2019-01-10
   * @param {*} state
   * @param {*} data
   */
  handleMenuList (state,data) {
    state.menuList = data
  },
  /**
   * @description 处理地址栏url路由
   * @author YM
   * @date 2019-01-14
   * @param {*} state
   * @param {*} data
   */
  handleRoutePath (state,data) {
    state.routePath = data
  },
  /**
  * @description 处理用户登录信息
  * @author YM
  * @date 2019-01-10
  * @param {*} state
  * @param {*} data
  */
  handleUserInfo (state,data) {
    state.userInfo = data
  },
  /**
    * @description 处理用户权限信息
    * @author YM
    * @date 2019-01-10
    * @param {*} state
    * @param {*} data
    */
  handleUserPermissions (state,data) {
    state.userPermissions = data
  },
  /**
   * @description 改变响应错误弹窗标志
   * @author YM
   * @date 2020-01-07
   * @param {*} state
   * @param {*} data  true|false
   */
  changeRespErrMsgBoxMark (state,data) {
    state.responseErrorMessageBoxMark = data
  },
  /**
   * @description 全局loading状态控制
   * @author YM
   * @date 2020-02-19
   * @param {*} state
   * @param {*} data  true|false
   */
  changeLoadingStatus (state,data) {
    state.loadingStatus = data
  },
  changeSwitchInfo (state, { key, value}) {
    state.switchInfo[key] = value
    // console.log(state.switchInfo)
  },
  handleDomainInfo (state, data) {
    state.domainInfo = data
  }
}

const actions = {
  // 首页切换公司和服务公司
  async initSwitch ({ dispatch, commit }) {
    // const companyList = await api.getUserCompany()
	// 商户和税源地合在一起
	const companyList = await api.getUserCompanySettlement()
    const settlementList = await api.getUserSettlement()
  // let companyList
  // api.getUserCompanySettlement().then(res=>{
  //   companyList = res
  //   commit('changeSwitchInfo', { key: 'companyList', value: companyList })
  // })
  //   const settlementList = await api.getUserSettlement()
    
	commit('changeSwitchInfo', { key: 'companyList', value: companyList })
    commit('changeSwitchInfo', { key: 'settlementList', value: settlementList })
    dispatch('initUserInfo')
  },
  // 获取用户信息
  async initUserInfo({ state, commit }) {
	console.log('初始化获取用户信息')
	const userRes = await api.getProfileNew()
	commit('changeSwitchInfo', { key: 'companyId', value: userRes.company_id })
	commit('changeSwitchInfo', { key: 'settlementId', value: userRes.settlement_id })
	
    const userInfo = await api.getUserProfile()
    if (userInfo) {
      // const { company_id,settlement_id,is_contract } = userInfo
      const { settlement_id,is_contract } = userInfo
      storage.set('is_contract', is_contract)
      storage.set('user_info', userInfo)
      if (is_contract <= 0 || is_contract == 2) {
        commit('handleCollapse', true)
      } else {
        commit('handleCollapse', false)
      }
      // userInfo.is_contract = 0    // debug
      commit('handleUserInfo', userInfo)
      commit('handleIsContract', is_contract)
      // commit('changeSwitchInfo', { key: 'companyId', value: company_id })
      // commit('changeSwitchInfo', { key: 'settlementId', value: settlement_id })
      let info = {}
      state.switchInfo.settlementList.forEach(item => {
        info[item.id] = item.yl_bank
        let xlwalipaylist = ['alipay','xlwalipay','xlwalipaydirect']
        let isalipay = xlwalipaylist.includes(info[settlement_id])
        commit('changeSwitchInfo', { key: 'isAlipay', value: isalipay })
      });
    }
    
    return userInfo
  }
}

const getters = {
  menuList: state => state.menuList,
  isCollapse: state => state.isCollapse,
  routePath: state => state.routePath,
  userInfo: state => state.userInfo,
  userPermissions: state => state.userPermissions,
  respErrMsgBoxMark: state => state.responseErrorMessageBoxMark,
  buttonType: state => state.buttonType,
  loadingStatus: state => state.loadingStatus,
}

export default new Vuex.Store({
  strict: false,
  state,
  getters,
  mutations,
  actions,
  modules
})
